var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 52,
    viewBox: "0 0 67 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2096 51.8333V24.0021L3.69297 30.5417L0.0429688 25.675L33.5013 0.125L45.668 9.40208V3.16667H54.793V16.3979L66.9596 25.675L63.3096 30.5417L54.793 24.0021V51.8333H39.5846V33.5833H27.418V51.8333H12.2096ZM27.418 21.4927H39.5846C39.5846 19.8705 38.9763 18.5392 37.7596 17.499C36.543 16.4587 35.1235 15.9396 33.5013 15.9417C31.8791 15.9437 30.4596 16.4638 29.243 17.502C28.0263 18.5403 27.418 19.8705 27.418 21.4927Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b09c0a7eae0efbfe27d0ad84ff3b0f3f.svg";
export { ForwardRef as ReactComponent };